import React, { FC, useRef, useEffect, ReactNode } from 'react'
import classNames from 'classnames'
import { Text, ButtonClose } from 'front-end/src/components'
import './Drawer.less'
import { brandColors } from '../../../../../../shared/basicPalette'
import { Flex } from '@chakra-ui/layout'
import { css } from '@emotion/react'
import { FlexProps, TextProps } from '@chakra-ui/react'

/**
 * @deprecated
 * import Drawer from components index
 */
export const Drawer: FC<{
  children: any
  title: string
  show?: boolean
  className?: string
  onHide: () => void
}> = (props) => {
  const drawerCssClasses = classNames('Drawer', props.className)
  const overlayEl = useRef<HTMLDivElement>(null)
  const { onHide, children } = props
  const keyUpHandler = (ev) => {
    if (ev.key === 'Escape' && props.show) {
      props.onHide()
    }
  }
  useEffect(() => {
    document.addEventListener('keyup', keyUpHandler)

    return () => {
      document.removeEventListener('keyup', keyUpHandler)
    }
  }, [onHide])

  return (
    <div
      className="Drawer__overlay"
      ref={overlayEl}
      // we use onMouseDown rather than onClick, because with onClick user can very easily accidentally close the drawer trying to select input contents inside the drawer
      onMouseDown={(e) => {
        if (e.target === overlayEl.current) {
          if (typeof onHide === 'function') {
            onHide()
          }
        }
      }}
      data-show={props.show}
    >
      <div className={drawerCssClasses}>
        <div className="Drawer__title">
          {props.title}
          <span className="Drawer__close">
            <ButtonClose onClick={onHide} />
          </span>
        </div>
        <div className="Drawer__body">{children}</div>
      </div>
    </div>
  )
}

export const DrawerItem = ({
  children,
  isInline = false,
  ...props
}: FlexProps & {
  children: ReactNode
  isInline?: boolean
}) => {
  return (
    <Flex
      p="12px"
      borderBottom={`1px solid ${brandColors.grey['200']}`}
      direction={isInline ? 'row' : 'column'}
      justify={isInline ? 'space-between' : 'flex-start'}
      {...props}
    >
      {children}
    </Flex>
  )
}

export const DrawerItemHeader = ({
  children,
  dataTest = 'DrawerHeader',
  ...props
}: FlexProps & { children: ReactNode; dataTest?: string }) => {
  return (
    <Flex
      mb="10px"
      align="center"
      css={css`
        .Icon {
          display: inline-flex;
          align-items: center;
          font-size: 16px;
          width: 16px;
          height: 16px;
          margin-right: 8px;
          color: ${brandColors.grey['500']};
        }
      `}
      data-test={dataTest}
      {...props}
    >
      {children}
    </Flex>
  )
}

export const DrawerItemHint = ({
  children,
  ...props
}: TextProps & { children: ReactNode }) => {
  return (
    <Text mt="8px" color={brandColors.grey.mid} fontSize="12px" {...props}>
      {children}
    </Text>
  )
}
